/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat =
  {
    Json: "json",
    Csv: "csv",
  } as const;
export type GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat =
  ClosedEnum<
    typeof GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat
  >;

export type GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest =
  {
    /**
     * End Timestamp
     */
    end?: number | null | undefined;
    format?:
      | GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat
      | undefined;
    /**
     * Start Timestamp
     */
    start?: number | null | undefined;
  };

/** @internal */
export const GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat
  > = z.nativeEnum(
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat,
  );

/** @internal */
export const GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat
  > =
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$ {
  /** @deprecated use `GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format:
      GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$inboundSchema
        .default("json"),
    start: z.nullable(z.number()).default(null),
  });

/** @internal */
export type GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$Outbound =
  {
    end: number | null;
    format: string;
    start: number | null;
  };

/** @internal */
export const GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format:
      GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearFormat$outboundSchema
        .default("json"),
    start: z.nullable(z.number()).default(null),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$ {
  /** @deprecated use `GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$Outbound;
}

export function getApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequestToJSON(
  getApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest:
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$outboundSchema
      .parse(
        getApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest,
      ),
  );
}

export function getApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest' from JSON`,
  );
}
